import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_STATUS_INITIALIZED,
  STORE_NOTIFICATION_CENTRAL,
  STORE_NOTIFICATION_CENTRAL_FETCH_STATUS,
} from 'constants/store'

import { ErrorStore } from '@types'
import {
  createGenericSlice,
  GenericState,
  createReducers,
  ExtraReducers,
} from 'stores/generics'
import { Payload } from 'stores'

export type NotificationCentralState = {
  hasNotifications: boolean
  count: number
}

type State = GenericState<NotificationCentralState>

export const initialState: State = {
  data: {
    hasNotifications: false,
    count: 0,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchStatus = createAsyncThunk<
  NotificationCentralState,
  Promise<NotificationCentralState>,
  Payload
>(
  STORE_NOTIFICATION_CENTRAL_FETCH_STATUS,
  async (promise: Promise<NotificationCentralState>, { rejectWithValue }) => {
    try {
      return await promise
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  NotificationCentralState,
  NotificationCentralState,
  Payload
>(fetchStatus, initialState.data)

const userSlice = createGenericSlice({
  name: STORE_NOTIFICATION_CENTRAL,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = userSlice

const { clear } = actions

export { clear }

export default reducer
